export default {
  title: 'Recortar imagen',
  cancel: 'Cancelar',
  cut: 'Recortar'
}

export const en = {
  title: 'Crop image',
  cancel: 'Cancel',
  cut: 'Crop'
}

export const ca = {
  title: 'Retallar imatge',
  cancel: 'Cancelar',
  cut: 'Retallar'
}
